import React from 'react';
import { useReveal } from '../lib/useReveal';
export function StatsBar() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#111111] py-6 border-y border-white/10 relative z-20" data-id="element-487">
      <div className="container mx-auto px-5" data-id="element-488">
        <div ref={ref1} className={`reveal flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-489">
          <div className="flex items-center gap-2" data-id="element-490">
            <span className="text-[#eab308] font-bold text-xl" data-id="element-491">+500</span>
            <span className="text-gray-300 text-sm uppercase tracking-wider font-medium" data-id="element-492">
              personas ya lo tienen
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-white/10" data-id="element-493"></div>
          <div className="flex items-center gap-2" data-id="element-494">
            <span className="text-[#eab308] font-bold text-xl" data-id="element-495">6</span>
            <span className="text-gray-300 text-sm uppercase tracking-wider font-medium" data-id="element-496">
              Tomos completos
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-white/10" data-id="element-497"></div>
          <div className="flex items-center gap-2" data-id="element-498">
            <span className="text-[#eab308] font-bold text-xl" data-id="element-499">6</span>
            <span className="text-gray-300 text-sm uppercase tracking-wider font-medium" data-id="element-500">
              Bonos incluidos
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-white/10" data-id="element-501"></div>
          <div className="flex items-center gap-2" data-id="element-502">
            <span className="text-[#eab308] font-bold text-xl" data-id="element-503">4.9/5</span>
            <span className="text-gray-300 text-sm uppercase tracking-wider font-medium" data-id="element-504">
              calificación ⭐
            </span>
          </div>
        </div>
      </div>
    </section>;
}